import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import VueMeta from 'vue-meta';
import { method } from "@/common/common.js";

Vue.config.productionTip = false;

import './style/MainStyle.scss';

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import './style/element-variables.scss';
Vue.use(ElementUI);

import 'font-awesome/css/font-awesome.min.css';

Vue.use(VueMeta)

router.beforeEach((to, from, next) => {

  const checkRecordToken = () => {
    let recordToken = localStorage.getItem('recordToken');
    if (recordToken) {
      next();
    } else {
      FingerprintJS.load().then(fp => {
        fp.get().then(result => {
          localStorage.setItem('recordToken', result.visitorId);
          next();
        });
      });
    }
  }

  method.supportsWebP((webP) => {
    store.state.supportWebP = webP;
    checkRecordToken();
  })
})

new Vue({
  router,
  store,
  render: function (h) { return h(App) },
}).$mount('#app')
